
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dex-aggregator-development",
      function () {
        return require("private-next-pages/dex-aggregator-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dex-aggregator-development"])
      });
    }
  